import service from '@/utils/request'

export function getSupplierPage(params) {
  return service.get('/uic-system_hf/hf_supplier/page', {
    params: {
      current: params?.current || 1,
      size: params?.size || 20,
      supplierName: params?.keyword || ''
    }
  })
}

export function getMaterialPage(params) {
  return service.get('/uic-system/material/page', {
    params: {
      materialNo: params?.materialNo || '',
      type: params?.type || 1,
      supplierId: params?.supplierId || '',
      supplierName: params?.supplierName || '',
      current: params?.current || 1,
      size: params?.size || 20,
      isCompose: params?.isCompose || 0
    }
  })
}

export function getWareList(params) {
  return service.get('/uic-system/ware/list', {
    params: {
      wareType: params?.wareType || 0,
      bizDept: params?.bizDept || ''
    }
  })
}

export function scanSubmit(data) {
  return service.post('/uic-system_hf/warein/ScanSubmit', data)
}
